import React, { useState, useRef, useMemo } from 'react'
import GoodsTable from './modules/goods-table/goods-table'
import GoodsGroup from './modules/goods-group/goods-group'
import { getBEMCls } from '@/utils/classname'

import './goods-library.scss'
import Button from '@/components/button/button'
import { showLayer, layerManage } from '@/utils/layer'
import { EditGoods } from './modules/edit-goods/edit-goods'
import { notification, Popover, Switch } from 'antd'
import { goodsModel } from './modules/edit-goods/modules/model'
import SearchInput from '@/components/search-input/search-input'
import { Expaned, Row } from '@/components/layout/layout'
import { GoodsRecordDialog } from './widget/goods-record-dialog'
import { GoodsChangeRecord } from './modules/goods-change-record/goods-change-record'
import { goodsLibraryStore } from './store/goods-library'
import classNames from 'classnames'
import $msg from '@/utils/message'
import EditPackage from './modules/edit-package/edit-package'
import { shopStore } from '@/store/shop'
import Auth from '@/views/main/components/auth/auth'
import ImportGood from '../../components/import-good/import-good'
import { useRequest, useUnmount } from 'ahooks'
import { $post } from '@/api'
import { Modal } from '@/components/dialog/modal'
import Axios from 'axios'
import { userStore } from '@/store/user'
import { download, errorCallBack } from '@/utils'
import GoodsLibrarySort from '../../components/sort-good/sort-good'
import ImportIng from '@/assets/images/import-ing.svg'

export const TYPE = 'DROP_TABLE'

const GoodsCenter = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('goods-library', e, m)
    const [visable, setVisable] = useState(false)
    const [keyWord, setKeyWord] = useState('')
    const [status, setStatus] = useState<boolean>(!!shopStore.shopConfig?.hide_off_shelf_goods)
    const errorReq = useRef<number>(0)

    const callback = useRef<any>(null)

    const importCb = () => {
        layerManage.pop()
        goodsLibraryStore.resetGoodTableData()
    }

    useUnmount(() => {
        goodsLibraryStore.resetSelectGroupNum()
    })

    const getImportStatus = useRequest(
        (recordId: number) =>
            $post({
                url: '/goods/migration/getgoodsimportstatus',
                params: {
                    record_id: recordId,
                },
            }),
        {
            manual: true,
            pollingInterval: 1000,
            onSuccess: res => {
                if (res.import_status === 1) {
                    getImportStatus.cancel()
                    if (res.imported_fail) {
                        showLayer(
                            <Modal
                                headerStyles={{ width: '440px' }}
                                isShow
                                type="danger"
                                style={{ height: '156px' }}
                                onClose={importCb}
                                onCancel={importCb}
                                onConfirm={() => {
                                    Axios.post(
                                        '/api/goods/migration/invalidgoodsexport',
                                        {},
                                        {
                                            headers: {
                                                Authentication: userStore.token,
                                                ShopAuthentication: localStorage.getItem('shopId'),
                                                'LS-Source': 'Web',
                                            },
                                            responseType: 'blob',
                                        },
                                    ).then(res => {
                                        let blob = new Blob([res.data], {
                                            type: 'application/vnd.ms-excel;charset=utf-8',
                                        })
                                        let disposition = res.headers['content-disposition']
                                        let saveName =
                                            (disposition && disposition.split(';')[1].split('=')[1].split('.')[0]) ||
                                            '失败的商品数据表格'
                                        download(blob, saveName)
                                    })
                                    importCb()
                                }}
                                okText="下载失败数据"
                            >
                                <div>
                                    <div data-font-size-20 data-font-weight-600 data-color-000>
                                        {res.imported_fail}条数据未导入成功
                                    </div>
                                    <div data-font-size-14 data-color-999 data-margin-top-8>
                                        可下载修正
                                    </div>
                                </div>
                            </Modal>,
                        )
                    } else {
                        layerManage.pop()
                        $msg('success', '导入成功')
                        goodsLibraryStore.resetGoodTableData()
                    }
                    callback.current && callback.current()
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
        },
    )

    const PopoverContentConfig = useMemo(() => {
        const tmp = [
            {
                name: '商品排序',
                onClick: () => {
                    setVisable(false)
                    showLayer(<GoodsLibrarySort />)
                },
            },
            {
                name: '新建商品套餐',
                onClick: () => {
                    setVisable(false)
                    if (shopStore.isChainShop) return $msg('warning', '连锁店请前往零售通APP操作')
                    showLayer(<EditPackage goodsModel={goodsModel} />)
                },
            },
            {
                name: '商品档案设置',
                onClick: () => {
                    setVisable(false)
                    showLayer(<GoodsRecordDialog />)
                },
            },
            {
                name: '商品变更记录',
                onClick: () => {
                    setVisable(false)
                    showLayer(<GoodsChangeRecord />)
                },
            },
            {
                name: '批量导入商品',
                onClick: () => {
                    setVisable(false)
                    showLayer(
                        <ImportGood
                            onImport={(record, cb) => {
                                callback.current = cb
                                getImportStatus.run(record)
                            }}
                        />,
                    )
                },
            },
        ]

        if (userStore.userInfo?.id === shopStore.shopInfo?.creator.id) {
            tmp.push({
                name: '导出全部商品',
                onClick: () => {
                    setVisable(false)
                    $post({
                        url: '/goods/exportshopgoods',
                    })
                        .then(() => {
                            notification.open({
                                icon: <img src={ImportIng} data-margin-top-10 alt="" />,
                                style: {
                                    borderRadius: '10px',
                                },
                                key: 'export-ing',
                                message: (
                                    <div data-color-000 data-font-size-20 data-font-weight-600>
                                        商品批量导出中
                                    </div>
                                ),
                                description: (
                                    <div data-color-000 data-font-size-14>
                                        请勿关闭网页/断开网络
                                    </div>
                                ),
                                duration: null,
                            })
                            exportGoodStatusReq.run()
                        })
                        .catch(e => {
                            errorCallBack(e)
                        })
                },
            })
        }

        return tmp
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userStore.userInfo, shopStore.shopInfo])

    const exportGoodStatusReq = useRequest(
        () =>
            $post({
                url: '/goods/getexportshopgoodsurl',
            }),
        {
            manual: true,
            pollingInterval: 2000,
            onSuccess: res => {
                if (res.sheet_url) {
                    notification.close('export-ing')
                    $msg('success', '导出成功')
                    download(res.sheet_url, '导出商品')
                    exportGoodStatusReq.cancel()
                }
            },
            onError: e => {
                if (errorReq.current <= 5) {
                    errorReq.current++
                } else {
                    errorCallBack(e)
                    notification.close('export-ing')
                    exportGoodStatusReq.cancel()
                    errorReq.current = 0
                }
            },
        },
    )

    const hideSettingReq = useRequest(
        (good_status: boolean) =>
            $post({
                url: '/shop/updateshopconfig',
                params: {
                    hide_off_shelf_goods: good_status,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                setStatus(!status)
                $msg('success', '操作成功')
            },
        },
    )

    return (
        <Expaned className={getCls()}>
            <div className={getCls('header')}>
                <Auth
                    onClick={() => {
                        showLayer(<EditGoods goodsModel={goodsModel} mode="create"></EditGoods>)
                    }}
                    perssion={25}
                >
                    <Button types="default">添加商品</Button>
                </Auth>

                <Popover
                    placement="bottomRight"
                    visible={visable}
                    onVisibleChange={() => setVisable(!visable)}
                    content={
                        <ul data-padding-v-10>
                            {PopoverContentConfig.map((i, index) => (
                                <li
                                    key={`${i.name}-${index}`}
                                    className={getCls('popover', 'item')}
                                    onClick={i.onClick}
                                >
                                    {i.name}
                                </li>
                            ))}

                            <li
                                className={getCls('popover', 'item')}
                                onClick={() => {
                                    hideSettingReq.run(!status)
                                }}
                            >
                                隐藏未上架商品
                                <span data-margin-left-10>
                                    <Switch loading={hideSettingReq.loading} checked={status}></Switch>
                                </span>
                            </li>
                        </ul>
                    }
                    trigger="click"
                >
                    <div>
                        <Button
                            types="more"
                            style={{
                                margin: '0 16px',
                            }}
                        >
                            更多操作
                        </Button>
                    </div>
                </Popover>
                <SearchInput
                    placeholder="搜索"
                    isExpaned={false}
                    onSearch={value => {
                        setKeyWord(value.trim())
                        goodsLibraryStore.setKeyWord(value.trim())
                    }}
                    onDelete={() => {
                        setKeyWord('')
                        goodsLibraryStore.setKeyWord('')
                    }}
                />
            </div>
            {keyWord && (
                <Row className={getCls('searchBox')}>
                    <div>
                        以下是
                        <span className={classNames('them-color')} data-padding-h-8>
                            {keyWord}
                        </span>
                        的搜索结果
                    </div>
                    <div
                        className={getCls('delete')}
                        onClick={() => {
                            setKeyWord('')
                            goodsLibraryStore.setKeyWord('')
                        }}
                    >
                        <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                    </div>
                </Row>
            )}
            <Expaned data-row className={getCls('content')}>
                <GoodsGroup goodsLibraryStore={goodsLibraryStore} />
                <GoodsTable goodsLibraryStore={goodsLibraryStore} />
            </Expaned>
        </Expaned>
    )
}

export default GoodsCenter
